/* eslint-disable react/style-prop-object */
import { useState } from "react";
import { FilterCircle, Layers, Trash } from "react-bootstrap-icons";
import ToggleButton from "../../../../../../components/ui/toggle_button/ToggleButton";
import Questionnaire from "../../../../../../libs/api/services/Questionnaire";
import DebouncesTextInput from "../DebouncesTextInput";
import AdminRTE from "./AdminRTE";
import FieldLinkContainer from "./link/FieldLinkContainer";
import FieldOptionsContainer from "./link/FieldOptionsContainer";
import FieldOptionsDynamicTableContainer from "./link/FieldOptionsDynamicTableContainer";

export default function AdminContainer({
  component,
  onPropertyChange,
  onComponentChange,
}) {
  const [activeTab, setActiveTab] = useState("General");
  console.log("AdminContainer component", activeTab);
  const renderQuestionText = (q) => {
    try {
      if (!q) return "";
      // If it's a string, try to detect a stringified JSON first
      if (typeof q === "string") {
        const trimmed = q.trim();
        if ((trimmed.startsWith("{") && trimmed.endsWith("}")) || (trimmed.startsWith("[") && trimmed.endsWith("]"))) {
          const parsed = JSON.parse(q);
          if (parsed && Array.isArray(parsed.blocks)) return parsed.blocks.map((b) => b.text || "").join(" ");
          // Some systems store blocks directly as an array
          if (Array.isArray(parsed)) return parsed.map((b) => b.text || "").join(" ");
        }
        // Fallback: plain string
        return q;
      }

      // DraftJS raw content state: { blocks: [ { text: '...' }, ... ] }
      if (q && Array.isArray(q.blocks)) return q.blocks.map((b) => b.text || "").join(" ");
      // Sometimes blocks are provided as the root array
      if (Array.isArray(q)) return q.map((b) => b.text || "").join(" ");

      return "";
    } catch (e) {
      return "";
    }
  };
  const renderSection = () => {
    switch (activeTab) {
      case "General":
        return (
          <>
            <div className=" p-2">
              {component ? (
                component.componentType === "Display Text" ? (
                  <AdminRTE
                    component={component}
                    onPropertyChange={(value) =>
                      onPropertyChange(
                        component.componentId,
                        "Question",
                        value,
                        false
                      )
                    }
                  />
                ) : (
                  <div>
                    <div className="d-flex justify-content-between">
                      <b>Enter a name for the field</b>
                    </div>
                    <DebouncesTextInput
                      onChange={(e) =>
                        onPropertyChange(
                          component.componentId,
                          "Question",
                          e,
                          false
                        )
                      }
                      className="form-control form-control-sm"
                      placeholder="Field Name"
                      defaultValue={component && renderQuestionText(component.question)}
                    />
                    <p className="text-muted">
                      This is the name of the field that will be displayed in
                      the questionnaire as well as on the reports.
                    </p>
                  </div>
                )
              ) : (
                <></>
              )}
              <div>
                <div className="d-flex justify-content-between">
                  <div>
                    <div>
                      <b>Is this field required?</b>
                    </div>
                    <div>
                      <ToggleButton
                        style="tick"
                        defaultValue={component && component.required}
                        onToggle={(t) =>
                          onPropertyChange(
                            component.componentId,
                            "Required",
                            t,
                            false
                          )
                        }
                      >
                        Field is required
                      </ToggleButton>
                    </div>
                  </div>
                </div>
                <p className="text-muted">
                  If selected the questionnaire will not allow to complete until
                  a value is entered.
                </p>
              </div>
            </div>
          </>
        );
      case "Link":
        return (
          <FieldLinkContainer
            component={component}
            onPropertyChange={onPropertyChange}
          />
        );
      case "Options":
        return (
          <>
            {component &&
              (component.componentType === "Single Selection" ||
                component.componentType === "Multiple Selection") && (
                <FieldOptionsContainer
                  component={component}
                  onPropertyChange={(values) =>
                    onPropertyChange(
                      component.componentId,
                      "Options",
                      values,
                      false
                    ).then(() => {
                      if (onComponentChange) onComponentChange();
                    })
                  }
                />
              )}
            {component &&
              (component.componentType === "Dynamic Component Table" ||
                component.componentType.type === "Dynamic Component Table") && (
                <FieldOptionsDynamicTableContainer
                  component={component}
                  onPropertyChange={(values) =>
                    onPropertyChange(
                      component.componentId,
                      "Options",
                      values,
                      false
                    ).then(() => {
                      if (onComponentChange) onComponentChange();
                    })
                  }
                />
              )}
          </>
        );
      case "Design":
        return (
          <div>
            {component &&
              (typeof component.componentType === "string"
                ? component.componentType === "Single Selection" ||
                component.componentType === "Multiple Selection"
                : component.componentType.type &&
                  typeof component.componentType.type === "string"
                  ? component.componentType.type === "Single Selection" ||
                  component.componentType.type === "Multiple Selection"
                  : false) && (
                <div>
                  <label>Display As</label>
                  <select
                    defaultValue={
                      component.properties.find(
                        (a) => a.property === "displayAs"
                      ) &&
                      component.properties.find(
                        (a) => a.property === "displayAs"
                      ).values
                    }
                    onChange={(e) =>
                      onPropertyChange(
                        component.componentId,
                        "displayAs",
                        e.target.value,
                        false
                      )
                    }
                    name="displayAs"
                    className="form-control form-control-sm"
                  >
                    <option value=""></option>
                    <option value="Buttons">Buttons</option>
                    <option value="Dropdown">Dropdown</option>
                  </select>
                </div>
              )}
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div>
      <div className="d-flex align-items-center bg-primary-container text-white rounded-top-left tex-white top-0 p-2 small">
        {component && component.componentType && (
          <div className="text-center">
            <p className="m-0 pe-1 p-0 text-light">
              {typeof component.componentType.type === "string"
                ? component.componentType.type
                : ""}{" "}
              Component
            </p>
          </div>
        )}
        {component && component.question && (
          <div className="text-center text-dark">
            <p className="p-0 m-0 text-white">
              {renderQuestionText(component.question)}
            </p>
          </div>
        )}
      </div>
      <div className="d-flex p-1">
        <div className="d-flex flex-column align-items-center p-1 ">
          <div>
            <div>
              <Layers />
            </div>
          </div>
          Clone
        </div>
        <div
          onClick={() => {
            Questionnaire.SetComponentType(component.componentId, {
              type: "New",
            }).then(() => {
              if (onComponentChange) onComponentChange();
              // Switch to new component drawer
              if (typeof window !== "undefined" && window.dispatchEvent) {
                window.dispatchEvent(
                  new CustomEvent("showNewComponentDrawer", {
                    detail: { componentId: component.componentId },
                  })
                );
              }
            });
          }}
          className="d-flex flex-column align-items-center p-1 "
        >
          <div>
            <div>
              <FilterCircle />
            </div>
          </div>
          Change component type
        </div>
        <div
          className="d-flex flex-column align-items-center p-1 "
          onClick={() => {
            Questionnaire.RemoveComponent(component.componentId).then(() => {
              if (onComponentChange) onComponentChange();
              if (typeof window !== "undefined" && window.dispatchEvent) {
                window.dispatchEvent(
                  new CustomEvent("hideDrawer", {
                    detail: { componentId: component.componentId },
                  })
                );
              }
            });
          }}
        >
          <div>
            <div>
              <Trash />
            </div>
          </div>
          Remove Component
        </div>
      </div>
      <div className="d-flex rounded bg-primary-container ">
        <button
          onClick={() => setActiveTab("General")}
          className={`p-2 border-0 ${activeTab === "General" && "active"}`}
          style={{
            fontWeight: activeTab === "General" ? "active" : "normal",
            width: "100%",
          }}
        >
          General
        </button>
        <button
          onClick={() => setActiveTab("Options")}
          className={`p-2 border-0 ${activeTab === "Options" && "active"}`}
          style={{
            fontWeight: activeTab === "Options" ? "active" : "normal",
            width: "100%",
          }}
        >
          Field Options
        </button>
        <button
          onClick={() => setActiveTab("Link")}
          className={`p-2 border-0 ${activeTab === "Link" && "active"}`}
          style={{
            fontWeight: activeTab === "Link" ? "active" : "normal",
            width: "100%",
          }}
        >
          Link
        </button>
        <button
          onClick={() => setActiveTab("Design")}
          className={`p-2 border-0 ${activeTab === "Design" && "active"}`}
          style={{
            fontWeight: activeTab === "Design" ? "active" : "normal",
            width: "100%",
          }}
        >
          Design
        </button>
      </div>
      <div className="text-primary">{renderSection()}</div>
    </div>
  );
}
